import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/user.service';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';
import { DomSanitizer } from '@angular/platform-browser';
import { FaviconService } from '../favicon.service';
import { Booking } from '../booking';

@Component({
  selector: 'app-bookings-etc',
  templateUrl: './bookings-etc.component.html',
  styleUrls: ['./bookings-etc.component.css']
})
export class BookingsEtcComponent implements OnInit {

  bookings: Booking[] = [];

  constructor(
    private userService: UserService,
    private httpService: HttpService,
    private loginService: LoginService,
    private sanitizer: DomSanitizer,
    private favicon: FaviconService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
   }

  ngOnInit() {
    this.httpService.getAllEtcBookings()
    .subscribe(res => {
      this.bookings = res;
    });
  }

}
